export default __webpack_public_path__ + "static/media/mike.7f26bca1.jpeg";